import cn from 'classnames';
import { Dispatch, memo } from 'react';

import AttachmentIcon from '../SVGIcons/AttachmentIcon';
import CloseIconV2 from '../SVGIcons/CloseIconV2';
import classes from './attach-file.module.scss';

type AttachFileProp = {
  value: File | null;
  onChange: Dispatch<File | null>;
  className?: string;
  isError?: boolean;
  required?: boolean;
  allowedFormats?: string;
  maxSize?: string;
};

function AttachFile({
  value,
  onChange,
  className,
  isError,
  required = false,
  allowedFormats = 'PDF, WORD, TXT, JPEG или PNG',
  maxSize = 'Не более 24МБ',
}: AttachFileProp) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const { files } = e.target;
    if (files) {
      onChange(files[0]);
      return;
    }
    onChange(null);
  };

  const clearValue = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onChange(null);
  };

  return (
    <div
      className={cn(
        classes.attachFile,
        {
          [classes['attachFile--error']]: isError,
          [classes['attachFile--selected']]: !!value,
          [classes['attachFile--required']]: required,
        },
        className,
      )}
    >
      <div className={classes.attachFile__body}>
        <AttachmentIcon className={classes.attachFile__icon} />
        <div className={classes.attachFile__bodyTextBlock}>
          <div className={classes.attachFile__bodyTextBlockTitle}>
            <span className={classes.attachFile__bodyTextBlockTitleSpan}>
              {value
                ? `${value.name} (${(value.size / 1_048_576).toFixed(2)} МБ)`
                : 'Прикрепить файл'}
            </span>
            <button
              className={classes['attachFile__close-icon-button']}
              type="button"
              onClick={clearValue}
            >
              <CloseIconV2 className={classes['attachFile__close-icon']} />
            </button>
          </div>
          <div className={classes.attachFile__bodyTextBlockSubtitle}>
            {allowedFormats}
            {' '}
            (
            {maxSize}
            )
          </div>
        </div>
      </div>
      <input
        key={value?.name ?? ''}
        title={
          value
            ? `${value.name} (${(value.size / 1_048_576).toFixed(2)} МБ)`
            : 'Файл не выбран'
        }
        className={classes.attachFile__input}
        type="file"
        onChange={handleChange}
      />
    </div>
  );
}

export default memo(AttachFile);
